import {Badge} from "flowbite-react";

const EducationValue = ({ education, type = "formal", index = 0, isVisible = false }) => {
    const colors = {
        formal: {
            card: 'from-blue-50/80 to-indigo-50/80',
            title: 'from-blue-700 to-indigo-700',
            badge: 'from-blue-500 to-indigo-600',
            institution: 'text-blue-800',
            accent: 'from-blue-400 to-indigo-500'
        },
        nonformal: {
            card: 'from-indigo-50/80 to-purple-50/80',
            title: 'from-indigo-700 to-purple-700',
            badge: 'from-indigo-500 to-purple-600',
            institution: 'text-indigo-800',
            accent: 'from-indigo-400 to-purple-500'
        }
    };

    const currentColors = colors[type] || colors.formal;
    
    return(
        <div className={`group relative bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-4 opacity-80'}`}>
            
            {/* Decorative line */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-slate-900 dark:bg-slate-400 rounded-t-2xl"></div>
            
            <div className="space-y-4">
                {/* Subject/Course Title */}
                <h3 className="text-xl font-bold text-slate-900 dark:text-white transition-colors duration-300">
                    {education.subject}
                </h3>

                {/* Duration Badge */}
                <div className="flex items-center">
                    <div className="inline-flex items-center px-4 py-2 bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200 font-semibold rounded-full text-sm">
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        {education.start} - {education.end}
                    </div>
                </div>

                {/* Institution */}
                <div className="flex items-center gap-2">
                    <div className="p-2 bg-slate-100 dark:bg-slate-700 rounded-lg">
                        <svg className="w-4 h-4 text-slate-700 dark:text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H9m0 0H7m-2 0h2m0 0h6M9 7h6m-6 4h6m-6 4h6" />
                        </svg>
                    </div>
                    <h4 className="text-lg font-bold text-slate-800 dark:text-slate-200 transition-colors duration-300">
                        {education.institution}
                    </h4>
                </div>

                {/* Description */}
                {education.description && (
                    <div className="relative">
                        <p className="text-slate-700 dark:text-slate-400 leading-relaxed font-light bg-slate-50 dark:bg-slate-900/50 rounded-lg p-4 border border-slate-200 dark:border-slate-700 transition-colors duration-300">
                            {education.description}
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}
export default EducationValue;